import React, {createContext, useContext, useState, useEffect, useMemo} from "react"
import {line_item_path, line_items_path} from "@/routes.js";

const headers = {
  "Content-Type": "application/json",
}
const CartContext = createContext({cart: null})

export const CartProvider = ({children, cart: _cart}) => {
  const [cart, setCart] = useState(_cart)

  useEffect(() => {
    setCart(_cart)
  }, [_cart]);

  const addLineItem = async (item, quantity) => {
    const response = await fetch(line_items_path(), {
      method: 'POST',
      headers,
      credentials: "same-origin",
      // credentials: 'include',
      body: JSON.stringify({
        id: item.id,
        quantity,
        order_token: cart.token
      })
    })
    const result = await response.json()

    setCart(result)
  }

  const deleteLineItem = async (item) => {
    const response = await fetch(line_item_path(item.id), {
      method: 'DELETE',
      headers,
      body: JSON.stringify({
        order_token: cart.token
      })
    })

    const result = await response.json()
    setCart(result)
  }

  const setLineItemQuantity = async (item, quantity) => {
    const response = await fetch(line_item_path(item.id), {
      method: 'PATCH',
      headers,
      body: JSON.stringify({quantity, order_token: cart.token })
    })

    const result = await response.json()

    setCart(result)
  }

  return (
    <CartContext.Provider
      value={{
        cart,
        setCart,
        addLineItem,
        deleteLineItem,
        setLineItemQuantity
      }}>
      {children}
    </CartContext.Provider>
  )
}

export const useCart = () => {
  const context = useContext(CartContext)

  if (!context)
    throw new Error("XContext must be called from within the XContextProvider")

  return context
}
